import type {Range} from '../util/Range';

export default function createIntegerPart<Total extends number>(
  _: number,
  total: Total,
): Range<Total> {
  const result = Math.floor(_) % total;
  return (result < 0 ? total + result : result) as Range<Total>;
}
